"use client"

import { debugLog } from '@/lib/debug'
import { AnalyticsCards } from "./analytics-cards"
import { useAnalyticsData } from "@/hooks/use-analytics-data"

/**
 * 📊 Analytics Dashboard - Компонент представления
 * 
 * Архитектурные принципы:
 * - Только отображение (Presentation Layer)
 * - Без бизнес-логики
 * - Подписка на данные через Observer Pattern
 * - Чистая функция React компонента
 */
export function AnalyticsDashboard() {
  debugLog('api', '🔄 [AnalyticsDashboard] Рендер:', new Date().toISOString())
  
  // 📡 Подписываемся на данные через сервис
  const { data } = useAnalyticsData()
  
  // 🎨 Только отображение - никакой бизнес-логики!
  return <AnalyticsCards data={data} />
} 